import { ApiBase } from '@/api/methods/ApiBase'

export namespace UsersApi {
  /**
   * ユーザ情報更新API
   *
   * @param nickname ニックネーム
   * @param avatarIconCode アイコンコード
   */
  export async function updateUser(nickname: string, avatarIconCode: string): Promise<void> {
    const params = {
      nickname: nickname,
      avatarIconCode: avatarIconCode,
    }
    await ApiBase.post(`/manage/users/update`, params)
  }

  /**
   * ユーザ削除API
   *
   * @param userId ユーザID
   */
  export async function deleteUser(userId: number): Promise<void> {
    await ApiBase.post(`/manage/users/${userId}/delete`)
  }

  /**
   * ユーザパスワード更新API
   *
   * @param userId ユーザID
   * @param newPassword 新しいパスワード
   */
  export async function updateUserPassword(userId: number, newPassword: string): Promise<void> {
    const params = {
      newPassword: newPassword,
    }
    await ApiBase.post(`/manage/users/${userId}/password/update`, params)
  }

  /**
   * 生徒ロック
   *
   * @param userId ユーザID
   */
  export async function lockUser(userId: number): Promise<void> {
    await ApiBase.post(`/manage/users/students/${userId}/lock`)
  }

  /**
   * 生徒ロック解除
   *
   * @param userId ユーザID
   */
  export async function unlockUser(userId: number): Promise<void> {
    await ApiBase.post(`/manage/users/students/${userId}/unlock`)
  }
}
